<template>
  <div class="notification-box">
    <div v-if="notifications.length > 0">
      <div
        class="notify"
        v-for="notification in notifications"
        :style="{ 'background-color': bgColor[notification.color].Color }"
        :key="notification.id"
        @click="handlerMark(notification, $event)"
      >
        <div class="flex">
          <div class="n-title box grow">
            <strong
              ><i :class="notification.icon"></i> {{ notification.title }} - #{{
                notification.id
              }}</strong
            >
          </div>
          <div class="n-date">
            {{ $moment(notification.date).fromNow() }}
            <i class="mdi mdi-clock"></i>
          </div>
        </div>
        <div class="n-desc">
          {{ notification.desc }}
        </div>
      </div>
    </div>
    <div v-else>
      <p style="text-align: center">Actualmente no tiene notificaciones</p>
    </div>
    <!-- <div class="see-all">See all notifications</div> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  emits: ["DisplayNotificationDot"],
  name: "NotificationBox",
  data() {
    return {
      notifications: [],
      notificationSound: {},
      request: null,
      intervalHasAlreadyStarted: false,
      bgColor: {
        0: { Color: "#b2dafa", TextColor: "#f0000" }, // Internal Request
        1: { Color: "#cfffca", TextColor: "#f0000" }, // External Request
        2: { Color: "", TextColor: "#ffffff" }, // Task
        3: { Color: "", TextColor: "#ffffff" }, // Objective
        4: { Color: "#fdfd96", TextColor: "#f0000" }, // Prospect
        5: { Color: "#caacf9", TextColor: "#f0000" }, // Deal
        6: { Color: "#7ff9c7", TextColor: "#f0000" }, // Contract
        7: { Color: "#e2e37e", TextColor: "#f0000" }, // EventType
        8: { Color: "#fdcae1", TextColor: "#f0000" }, // Appointment
        9: { Color: "#ffda9e", TextColor: "#f0000" }, // Gantt
        10: { Color: "#ffda9e", TextColor: "#f0000" }, // Gantt
        11: { Color: "#ffda9e", TextColor: "#f0000" }, // Gantt
        12: { Color: "#d8f8e1", TextColor: "#f0000" }, //Maintenance calendar
        13: { Color: "#84b6f4", TextColor: "#ffffff" }, //Vacation Module
        14: { Color: "#77dd77", TextColor: "#f0000" }, //Permission Module
        15: { Color: "#ff9688", TextColor: "#ffffff" }, //Admonition Module
        16: { Color: "#95e0f2", TextColor: "#f0000" }, //Admonition Module
        17: { Color: "#95e0f2", TextColor: "#f0000" }, //Admonition Module
        18: { Color: "#95e0f2", TextColor: "#f0000" }, //Admonition Module
        19: { Color: "#B2D39DFF", TextColor: "#f0000" } // Ventafiel
      }
      // notifications: [
      //    {
      //      id: 1,
      //      title: "New order",
      //      icon: "mdi mdi-cart-outline",
      //      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam in diam sit amet felis ultricies ultricies vitae et tortor. Proin dapibus justo felis, ut imperdiet lacus accumsan quis.",
      //      date: new Date(2021, 3, 22)
      //    },
      //    {
      //      id: 2,
      //      title: "New Schedule Realease",
      //      icon: "mdi mdi-calendar",
      //      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam in diam sit amet felis ultricies ultricies vitae et tortor. Proin dapibus justo felis, ut imperdiet lacus accumsan quis.",
      //      date: "2 Min Ago"
      //    },
      //    {
      //      id: 3,
      //      title: "New message from David",
      //      icon: "mdi mdi-email-outline",
      //      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam in diam sit amet felis ultricies ultricies vitae et tortor. Proin dapibus justo felis, ut imperdiet lacus accumsan quis.",
      //      date: "30 Min Ago"
      //    }
      // ]
    };
  },
  computed: {
    ListOfNotificationIDs() {
      if (this.notifications.length === 0) return [];
      return this.notifications.map((m) => m.id);
    },
    AmountOfNotications() {
      return this.notifications.length;
    }
  },
  methods: {
    async handlerMark(notification) {
      const response = await this.$http.post(
        "/api/Notifications/MarkNotificationAsRead",
        notification.id
      );
      if (response.status === 200) {
        if (this.$router.currentRoute.path !== notification.redirectPath) {
          this.$router.push(notification.redirectPath);
        }

        this.RunNotificacionProcess();

        // Delete the notification from the notification box
        const selectedNotificationIndex = this.notifications.findIndex(
          (n) => n.id == notification.id
        );
        if (selectedNotificationIndex >= 0) {
          this.notifications.splice(selectedNotificationIndex, 1);
        }
      }
    },
    async RunNotificacionProcess() {
      if (this.request) this.request.cancel();

      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

      const { data } = await this.$http.get(
        "/api/Notifications/GetUnreadNotifications",
        {
          params: {
            employeeID: this.currentUser.EmployeeId,
            ListOfNotificationIDs: this.ListOfNotificationIDs
          },
          cancelToken: axiosSource.token
        }
      );
      let news = this.formatNotifications(data);

      for (let index = 0; index < news.length; index++) {
        const element = news[index];
        this.notifications.push(element);

        // Play Audio
        this.notificationSound.play();

        setTimeout(() => {
          // Notification popup (Without the timeout, all the notifications will be grouped and therefore unreadable)
          //console.log("Notification popup: ", element, "\n data: ", news)
          //const array = element.desc.split("vendedor");
          //const result = array.pop();
          if (element.title === "Actualización Prospecto") {
            this.$notify.info({
              title: element.desc,
              //message: result,
              offset: 50,
              duration: 0,
              customClass: "el-notification" + element.color
            });
          } else {
            this.$notify.info({
              title: `${element.title} #${element.relatedEntityID}`,
              message: element.desc,
              offset: 50,
              duration: 0,
              customClass: "el-notification" + element.color
            });
          }

          document
            .querySelectorAll(".el-notification" + element.color)
            .forEach((el) => {
              el.style.background = this.bgColor[element.color].Color;
              el.style.borderColor = this.bgColor[element.color].Color;

              el.querySelectorAll(".el-notification__title").forEach((tit) => {
                tit.style.color = this.bgColor[element.color].TextColor;
              });
            });
        }, 300);

        this.notifyMe(`${element.title} #${element.relatedEntityID}`);
      }
    },
    async loadNotificacion() {
      if (this.intervalHasAlreadyStarted == false) {
        this.intervalHasAlreadyStarted == true;
        setInterval(async () => {
          if (this.currentUser.EmployeeId !== undefined) {
            await this.RunNotificacionProcess();
          }
        }, 10000);
      }
    },
    formatNotifications(notificationsArray) {
      notificationsArray = notificationsArray.map(function (notification) {
        let titleFirstPart = "";
        let titleSecondPart = "";
        let icon = "";
        let redirectPath = "";
        let description = "";
        let color = "";

        // Changes title depending on whether the entity that produced the notification was created or updated
        switch (notification.Type) {
          case 0:
            if (
              notification.NotificationFrom == 3 ||
              notification.NotificationFrom == 4 ||
              notification.NotificationFrom == 6 ||
              notification.NotificationFrom == 7 ||
              notification.NotificationFrom == 14
            ) {
              titleFirstPart = "Nuevo ";
            } else {
              titleFirstPart = "Nueva ";
            }
            break;
          case 1:
            titleFirstPart = "Actualización ";
            break;
        }

        // Changes title, icon and, redirect-path depending on the entity that produced the notification
        switch (notification.NotificationFrom) {
          case 0: // Internal Request
            titleSecondPart = "Solicitud Interna";
            icon = "mdi mdi-format-list-bulleted";
            redirectPath = "/internal-requests";
            color = 0;
            break;
          case 1: // External Request
            titleSecondPart = "Solicitud Externa";
            icon = "mdi mdi-headphones";
            redirectPath = "/technical_support/requests";
            color = 1;
            break;
          case 2: // Task
            titleSecondPart = "Tarea";
            icon = "mdi mdi-clipboard-text-outline";
            redirectPath = "/cmi/objectives";
            color = 2;
            break;
          case 3: // Objective
            titleSecondPart = "Objetivo";
            icon = "mdi mdi-ballot";
            redirectPath = "/cmi/objectives";
            color = 3;
            break;
          case 4: // Prospect
            titleSecondPart = "Prospecto";
            icon = "mdi mdi-sale";
            redirectPath = "/sales/prospects/";
            color = 4;
            break;
          case 5: // Deal
            titleSecondPart = "Oportunidad";
            icon = "mdi mdi-sale";
            redirectPath = "/sales/deals/";
            color = 5;
            break;
          case 6: // Contract
            titleSecondPart = "Contrato";
            icon = "mdi mdi-sale";
            redirectPath = "/finances/contracts";
            color = 6;
            break;
          case 7: // EventType
            titleSecondPart = "Evento";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/calendar";
            color = 7;
            break;
          case 8: // Appointment
            titleSecondPart = "Cita";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/calendar";
            color = 8;
            break;
          case 9: // Gantt
            titleSecondPart = "Gantt Objetivos";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/cmi/GanttObjectives";
            color = 9;
            break;
          case 10: // Gantt
            titleSecondPart = "Gantt Tareas";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/cmi/GanttObjectives";
            color = 10;
            break;

          case 11: // Appointment
            titleSecondPart = "Tarea Re-Abierta";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/cmi/GanttObjectives";
            color = 11;
            break;

          case 12: // Maintenance calendar
            titleSecondPart = "Agenda De Mantenimiento";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/Agenda-maintenance";
            color = 12;
            break;

          case 13: // Vacation Module
            titleSecondPart = "Vacaciones";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/employees/ModulosRRHH#";
            color = 13;
            break;

          case 14: // Permission Module
            titleSecondPart = notification.Description.includes("Licencia")
              ? "Licencia"
              : notification.Description.includes("Permiso")
              ? "Permiso"
              : "Ausencia";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/employees/ModulosRRHH#";
            color = 14;
            break;

          case 15: // Admonition Module
            titleSecondPart = "Amonestación";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/employees/ModulosRRHH#";
            color = 15;
            break;

          case 16: // Admonition Module
            titleSecondPart = "Nomina Aprobada por RRHH";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/employees/Nomina#";
            color = 16;
            break;

          case 17: // Admonition Module
            titleSecondPart = "Nomina Aprobada por Finanzas";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/employees/Nomina#";
            color = 17;
            break;

          case 18: // Admonition Module
            titleSecondPart = "Nomina Aprobada por CEO";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/employees/Nomina#";
            color = 18;
            break;

          case 19: // Admonition Module
            titleSecondPart = "Notificacion de Ventafiel";
            icon = "mdi el-icon-notebook-1";
            redirectPath = "/#";
            color = 19;
            break;
        }

        // Limits descriptions to 60 characters
        if (notification.Description) {
          if (
            notification.Description.length > 60 &&
            notification.NotificationFrom !== 4
          ) {
            description = notification.Description.substring(0, 57) + "...";
          } else {
            description = notification.Description;
          }
        }

        return {
          id: notification.ID,
          relatedEntityID: notification.RelatedEntityID,
          desc: description,
          date: notification.CreatedAt,
          title: titleFirstPart + titleSecondPart,
          icon: icon,
          redirectPath: redirectPath,
          color: color
        };
      });

      return notificationsArray;
    },
    notifyMe(message) {
      // Let's check if the browser supports notifications
      if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
      }

      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === "granted") {
        // If it's okay let's create a notification
        new Notification(message);
      }

      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === "granted") {
            new Notification(message);
          }
        });
      }

      // At last, if the user has denied notifications, and you
      // want to be respectful there is no need to bother them any more.
    }
  },
  watch: {
    AmountOfNotications(amount) {
      this.$emit("DisplayNotificationDot", amount);
    }
  },
  created() {
    // Notificaciones se tornan una molestia en desarrollo
    // process.env.NODE_ENV !== "development"
    if (process.env.NODE_ENV !== "development") {
      this.RunNotificacionProcess();
      this.loadNotificacion();
      this.notificationSound = new Audio(
        require("../assets/Notification-02.wav")
      );
      this.notificationSound.volume = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";

.notification-box {
  color: $text-color;
  width: 100%;

  .notify {
    width: 102%;
    margin-bottom: 20px;
    max-height: 90px;
    overflow: hidden;
    position: relative;
    // &::after {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   bottom: 0;
    //   left: 0;
    //   right: 0;
    //   width: 100%;
    //   height: 20px;
    //   box-shadow: 0px -20px 20px -10px $background-color inset;
    // }

    .n-title {
      text-align: left;
      padding-right: 10px;
      font-size: 14px;
    }
    .n-desc {
      color: black;
      margin-bottom: 5px;
      font-size: 13px;
    }
    .n-date {
      font-size: 12px;
    }

    &:hover {
      color: $text-color-accent;

      .n-desc {
        color: transparentize($text-color-accent, 0.5);
      }
    }
    cursor: pointer;
  }

  .see-all {
    &:hover {
      color: $text-color-accent;
    }
  }
}
</style>
